import type { ReportStatus, ReportType } from "@/common/model";
import {
	createLabelTag,
	createStatusBadge,
	type TagStatus,
} from "../status-pill";

const statusColorMap: Record<ReportStatus, TagStatus> = {
	OPEN: "processing",
	SEALED: "success",
};

export const ReportStatusLabelMap: Record<ReportStatus, string> = {
	OPEN: "Open",
	SEALED: "Sealed",
};

export const ReportTypeLabelMap: Record<ReportType, string> = {
	INCIDENT: "Incident",
	INVESTIGATION: "Investigation",
	GENERIC: "Generic",
};

export const ReportStatusBadge = createStatusBadge(
	statusColorMap,
	ReportStatusLabelMap,
);

export const ReportTypeBadge = createLabelTag(ReportTypeLabelMap);
